import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'

function index (props) {
  const user = JSON.parse(localStorage.getItem('user'))
  return <>{user?.RoleId == '12' ? <Outlet /> : <Navigate to='/login' />}</>
}

export default index
